import { useId, useState } from 'react'

import type { FactBinding } from '../types'

export function FactDefinition({
  name,
  definition,
}: {
  name: string
  definition: FactBinding['definition']
}) {
  const [expanded, setExpanded] = useState(false)
  const id = useId()
  if (!definition || definition.kind === 'constant')
    return <span className="text-muted-foreground">—</span>

  return (
    <div className="w-72 max-w-72 space-y-1">
      <code className="block truncate text-xs">{definition.jinja_source}</code>
      <button
        type="button"
        className="text-xs text-muted-foreground underline underline-offset-4 hover:text-foreground"
        aria-label={`${expanded ? 'Hide' : 'View'} definition of ${name}`}
        aria-expanded={expanded}
        aria-controls={expanded ? id : undefined}
        onClick={() => setExpanded(!expanded)}>
        {expanded ? 'Hide definition' : 'View definition'}
      </button>
      {expanded && (
        <pre
          id={id}
          role="region"
          aria-label={`Definition of ${name}`}
          tabIndex={0}
          className="max-h-48 overflow-auto rounded border bg-muted/40 p-2 text-xs whitespace-pre-wrap break-words">
          {definition.jinja_source}
        </pre>
      )}
    </div>
  )
}
